/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */

import { Component, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';
import { Subscription } from 'rxjs';

import { LegalContentSettings } from '../../../../../../shared/db-models/media';
import { defaultLegalContentItems } from '../../../../../../shared/defaultLegalContentItems';

@Component({
  selector: 'app-legal-content-manager',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './template.html',
})
export class LegalContentManagerComponent {
  form: FormGroup;

  private fb: FormBuilder;
  private db: AngularFirestore;

  @AutoUnsubscribe()
  dataSubscription$: Subscription;

  constructor() {
    this.fb = inject(FormBuilder);
    this.db = inject(AngularFirestore);

    this.form = this.fb.group({
      items: this.fb.array([]),
      overridden: false,
    });

    // Loop through default items and populate the 'items' FormArray
    for (const item of defaultLegalContentItems) {
      const itemGroup = this.fb.group({
        htmlContent: [item.htmlContent],
        title: [item.title],
      });
      this.items.push(itemGroup);
    }

    this.dataSubscription$ = this.db
      .doc<LegalContentSettings>('media/legalContent')
      .valueChanges()
      .subscribe((data) => {
        if (data) {
          this.form.patchValue({
            overridden: data.overridden,
          });

          this.items.clear();

          for (const item of data.items) {
            const itemGroup = this.fb.group({
              htmlContent: item.htmlContent,
              title: item.title,
            });
            this.items.push(itemGroup);
          }
        }
      });
  }

  get items() {
    return this.form.get('items') as FormArray;
  }

  deleteItem(index: number) {
    if (confirm('Are you sure you want to remove this item?')) {
      this.items.removeAt(index);
    }
  }

  moveUp(index: number) {
    if (index === 0) return;
    const item = this.items.at(index);
    this.items.removeAt(index);
    this.items.insert(index - 1, item);
  }

  moveDown(index: number) {
    if (index === this.items.length - 1) return;
    const item = this.items.at(index);
    this.items.removeAt(index);
    this.items.insert(index + 1, item);
  }

  addItem() {
    const item = this.fb.group({
      htmlContent: '',
      title: '',
    });

    this.items.push(item);
  }

  onSubmit() {
    const legalContentSettings: LegalContentSettings = this.form.value;
    this.db.doc('media/legalContent').set({ ...legalContentSettings });
  }
}
